import SideBar from "app/analista/page-analist/interfaces/components/side-bar/side-bar"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import SideBarDetalleNegocio from "../components/sidebar/sidebar-detalle-negocio"
import CardScoring from "../components/card/card-scoring"
import Logout from "app/analista/page-analist/interfaces/components/banner/logout"
import { DetalleNegocioDTO } from "app/analista/adapters/dto/detalle-solicitud-dto"
import solicitudHubspotNuevo from "app/analista/adapters/ports/solicitudes-hubspot"
import {SolicitudesHubspotDTO} from "app/analista/adapters/dto/solicitudes-hubspot-dto"
import type { FormularioRespuestaDTO } from "app/analista/scoring/adapters/dto/resultado-dto"

interface ExtendedDetailDTO extends DetalleNegocioDTO {
  scoringResult?: FormularioRespuestaDTO
  approved?: boolean
  score?: number
  resume?: Record<string, number | boolean | string>
}

export default function DetalleSolicitudPorRevisar() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)
  const [detalleNegocio, setDetalleNegocio] = useState<ExtendedDetailDTO | null>(null)
  const [dealstageTabla, setDealstageTabla] = useState<SolicitudesHubspotDTO | null>(null)

  const location = useLocation()
  const navigate = useNavigate()
  const initialSolicitudData = location.state?.solicitud

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  const handleBack = () => {
    navigate(-1)
  }

  useEffect(() => {
    const fetchDetalleNegocio = async () => {
      const detalle = await solicitudHubspotNuevo.obtenerPorId(initialSolicitudData.hs_object_id)
      setDetalleNegocio(detalle as ExtendedDetailDTO)
      
      if (initialSolicitudData.dealstage) {
        setDealstageTabla({
          dealstage: initialSolicitudData.dealstage,
          hs_object_id: initialSolicitudData.hs_object_id,
        } as SolicitudesHubspotDTO)
      }
    }
  
    if (initialSolicitudData?.hs_object_id) {
      fetchDetalleNegocio()
    } else {
      navigate("/solicitudes-por-revisar");
    }
  }, [initialSolicitudData, navigate])

  if (!initialSolicitudData) {
    navigate("/solicitudes-por-revisar")
    return null
  }

  return (
    <div className="flex h-screen overflow-hidden">
      <SideBar isOpen={isSidebarOpen} onToggle={toggleSidebar} />
      <div className={`flex-1 p-5 ${isSidebarOpen ? "ml-[85px]" : "ml-[315px]"} overflow-hidden relative`}>
        <div className="absolute top-5 w-full flex justify-between px-10">
          <div className="text-xs text-[#718096] mt-1.5 -ml-4">
            <span className="cursor-pointer" onClick={handleBack}>
              Solicitudes por revisar
            </span>
            <span className="text-xs font-bold">/ Detalle de solicitud</span>
          </div>
          <Logout />
        </div>
        <div className="pt-16 flex h-full">
          <div className="w-[320px]">
            <SideBarDetalleNegocio solicitud={detalleNegocio} solicitudTabla={dealstageTabla}/>
          </div>
          <div className="flex-1 flex min-w-0 -ml-4 mr-2">
            <CardScoring 
              solicitud={detalleNegocio} 
              setSolicitud={setDetalleNegocio} 
              solicitudTabla={dealstageTabla}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

